import { useState } from 'react'
import { downloadApplePass } from '../../../utilities/api'
import { showAppleWalletButton } from '../../../utilities/walletDevice'

import Button from 'react-bootstrap/Button'
import Modal from 'react-bootstrap/Modal'

import addToAppleWalletSVG from '../../../assets/icons/add-to-apple-wallet-logo.svg'

export default function ApplePassButton({ event, obj, alwaysShow = false }) {
  const [errorModal, setErrorModal] = useState({ show: false, message: '' })
  const showError = (message) => setErrorModal({ show: true, message })
  const hideError = () => setErrorModal((s) => ({ ...s, show: false }))

  const downloadAppleWalletPass = async () => {
    const payload = {
      event,
      obj,
    }
    try {
      const response = await downloadApplePass(payload)

      if (response.status === 200) {
        let contentType = response.headers['content-type']
        const blob = new Blob([response.data], { type: contentType })
        console.log('blob: ', blob)
        console.log(`Received Blob: Type = ${blob.type}, Size = ${blob.size}`)

        const url = window.URL.createObjectURL(blob)
        const a = document.createElement('a')
        a.style.display = 'none'
        a.href = url
        a.download = 'event.pkpass'
        document.body.appendChild(a)
        a.click()
        setTimeout(() => {
          window.URL.revokeObjectURL(url)
          document.body.removeChild(a)
        }, 100)
      } else {
        console.error(
          'Failed to download the Apple pass.',
          response.status,
          response.data
        )
        showError(
          `Could not download your Apple Wallet pass (HTTP ${response.status}).`
        )
      }
    } catch (err) {
      console.error(
        'Failed to download the Apple pass.',
        err.response?.status,
        err.response?.data ?? err.message
      )
      showError('Could not download your Apple Wallet pass. Please try again.')
    }
  }

  if (!alwaysShow && !showAppleWalletButton()) return null

  return (
    <>
      <Button
        onClick={downloadAppleWalletPass}
        variant="info"
        aria-label="Add to Apple Wallet"
        className="wallet-pass-btn wallet-pass-btn--apple mt-0"
      >
        <img src={addToAppleWalletSVG} alt="add to apple wallet" />
      </Button>
      <Modal
        show={errorModal.show}
        onHide={hideError}
        centered
        backdrop="static"
      >
        <Modal.Header closeButton>
          <Modal.Title>Apple Wallet</Modal.Title>
        </Modal.Header>
        <Modal.Body>{errorModal.message}</Modal.Body>
        <Modal.Footer>
          <Button variant="primary" onClick={hideError}>
            OK
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  )
}
